(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cl-print-house"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope) => {
      const roots = scope.matches?.('[data-cl-print-house]') ? [scope] : scope.querySelectorAll('[data-cl-print-house]');
      roots.forEach((root) => {
        if (root.dataset.clPrintReady) return;
        const track = root.querySelector('[data-cl-print-track]');
        const cards = Array.from(root.querySelectorAll('[data-cl-print-card]'));
        const controls = root.querySelector('[data-cl-print-controls]');
        if (!track || !controls || cards.length < 2) return;
        root.dataset.clPrintReady = 'true';
        const previous = root.querySelector('[data-cl-print-prev]');
        const next = root.querySelector('[data-cl-print-next]');
        const current = root.querySelector('[data-cl-print-current]');
        let index = 0;
        let frame = 0;
        const update = () => {
          const start = track.getBoundingClientRect().left + parseFloat(getComputedStyle(track).paddingLeft);
          let nearest = Infinity;
          cards.forEach((card, position) => {
            const distance = Math.abs(card.getBoundingClientRect().left - start);
            if (distance < nearest) { nearest = distance; index = position; }
          });
          current.textContent = String(index + 1).padStart(2, '0');
          previous.disabled = index === 0;
          next.disabled = index === cards.length - 1;
        };
        const move = (direction) => {
          const destination = Math.max(0, Math.min(cards.length - 1, index + direction));
          const card = cards[destination];
          const padding = parseFloat(getComputedStyle(track).paddingLeft);
          const left = track.scrollLeft + card.getBoundingClientRect().left - track.getBoundingClientRect().left - padding;
          track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        previous.addEventListener('click', () => move(-1));
        next.addEventListener('click', () => move(1));
        track.addEventListener('keydown', (event) => {
          if (event.target !== track) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
        });
        track.addEventListener('scroll', () => {
          if (frame) cancelAnimationFrame(frame);
          frame = requestAnimationFrame(update);
        }, { passive: true });
        if ('ResizeObserver' in window) new ResizeObserver(update).observe(track);
        controls.hidden = false;
        update();
      });
    };
    initialize(document);
    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
